const removeCookieCSR = (name: string) => {
  if (typeof document === 'undefined') return
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC'
  const cookie = `${name}=; ${expires}; path=/`
  document.cookie = cookie
  return cookie
}

export { removeCookieCSR }
